import { Flex } from '@chakra-ui/layout';
import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { ImplementationsList } from '~/packages/implementations/ui/list/ImplementationsList';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  return (
    <ImplementationsList
      organizationId={user.organization.id}
      implementationRoutePrefix="/implementations/"
    />
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/" />;
    }}
  >
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <RouteBase />
    </Flex>
  </RouteErrorBoundary>
);
